<template>
  <div>
    <v-flex v-if="helpItems.length" class="py-3 px-2 flex-end">
      <span>Can't find what you're looking for?</span>
      <v-btn
        class="pf-btn-sm-2 pf-text-teal border-radius-15"
        title="Submit Content"
        @click="openHelpDesk"
      >
        Send to Help Desk
      </v-btn>
    </v-flex>
    <v-expansion-panel class="px-2 box-shadow-none" id="expansion-panel" v-model="panels" expand>
      <v-expansion-panel-content
        class="my-1 pf-bg-teal white--text border-radius-top-15"
        v-for="(item, i) in helpItems"
        :key="i"
      >
        <template v-slot:actions>
          <v-icon color="white">$vuetify.icons.expand</v-icon>
        </template>
        <template v-slot:header>
          <div><b>{{ i + 1 }}. {{ item.title }}</b></div>
        </template>
        <v-card>
          <v-card-text v-html="item.description"></v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-flex v-if="!helpItems.length" class="pf-font-16 font-weight-medium py-4 px-2 flex-center flex-column">
      <span>We didn't find any matched topics</span>
    </v-flex>

    <v-flex class="py-4 px-2 flex-center flex-column">
      <span>Can't find what you're looking for?</span>
      <v-btn
        class="pf-btn-sm-2 pf-text-teal border-radius-15"
        title="Submit Content"
        @click="openHelpDesk"
      >
        Send to Help Desk
      </v-btn>
    </v-flex>

    <app-modal :active="isHelpWindowOpen" v-if="isHelpWindowOpen" width="30%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="closeHelpModal">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Help - Profile Layout</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="helpForm">
              <!-- <v-text-field v-model.trim="enquiry.name" :rules="[v => !!v || 'Enter your name']" label="Full name" class="required pr-4 pl-4"></v-text-field> -->
              <!-- <v-text-field :rules="[v => !!v || 'Enter your email address', v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(v) || 'Please enter a valid email address']" v-model.trim="enquiry.email" label="Email address" class="required pr-4 pl-4"></v-text-field> -->
              <v-textarea v-model="enquiry.message" :rules="[v => !!v || 'Please type your message']" rows="4" label="Message" class="required pr-4 pl-4"></v-textarea>

            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="pf-btn-text-white pf-bg-green"
              @click="sendHelp"
            >
              Send
            </v-btn>
            <v-btn
              class="pf-btn-text-white pf-bg-pink"
              @click="closeHelpModal"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal>

  </div>
</template>
<script>

/* global session store */
import Vue from 'vue';
import moment from 'moment-timezone';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import AppModal from '../../components/AppModal';
import { request } from '../../helpers/helpers';
export default {
  name: 'profile-help',
  components: {
    VuePerfectScrollbar,
    'app-modal': AppModal
  },
  props: {
    helpItems: {
      type: Array,
      default: []
    }
  },
  data: () => ({
    session: session,
    moment: moment,
    panels: [],
    isHelpWindowOpen: false,
    enquiry: {
      // name: '',
      // email: '',
      message: ''
    }
  }),
  computed: {
    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      }
    },
    tipsRef: {
      get () {
        return this.tipsTabs;
      },
      set (value) {
        // 
      }
    },

  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    if (this.helpItems.length) {
      this.helpItems.forEach((help, i) => {
        this.panels.push(i ? false : true);
      });
    }
  },
  methods: {
    openHelpDesk () {
      this.isHelpWindowOpen = true;
    },

    closeHelpModal () {
      this.isHelpWindowOpen = false;
      this.enquiry = {
        // name: '',
        // email: '',
        message: ''
      };
    },
    async sendHelp () {
      if (this.$refs.helpForm.validate() && this.enquiry.message && this.enquiry.message.trim()) {
        let { error, data } = await request('Email/profileLayoutHelp', 'POST', { account: this.Account.id, message: this.enquiry.message.trim() });
        if (error) {
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to send your request.'
          };
        } else {
          this.snackbar = {
            show: true,
            color: 'green',
            text: 'Thanks, our team will contact you soon.'
          };
        }
        this.closeHelpModal();
      }
    },
  }
};
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/ProfileDocuments/help.vue